import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { projectsActions } from '@src/store/reducers/projectsReducer';
import { userActions } from '@src/store/reducers/userReducer';

import * as _ from 'lodash';

@Component({
    selector: 'project-group-item',
    template: require('./project-group-item.component.html'),
    styles: [require('./project-group-item.component.scss')]
})
export class ProjectGroupItemComponent implements OnInit, OnDestroy {
    @Input() public set projectGroup(value) {
        this._tempProjectGroup = this.deepCopy(value);
        this._projectGroup = value;
        this.setProjectsInGroup();
    }

    public get projectGroup() {
        return this._projectGroup;
    }

    @Output() public onDelete = new EventEmitter();

    public projectsInProjectGroup: any[] = [];
    public pathTypeOptions: any[] = [];

    private _projectGroup: any;
    private unSubscribers: any[];
    private unSubscribePathType2: any;
    private unSubscribe: any;
    private _tempProjectGroup: any;
    private projects: any[];

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
    }

    public ngOnInit() {
        this.unSubscribers = [
            this.store.subscribe(() => {
                const projectItems = this.store.getState().projects.projectItems;
                if (projectItems) {
                    this.projects = _.orderBy(_.filter(projectItems, (x: any) => !x.isDraft), ['name'], ['asc']);
                    this.setProjectsInGroup();
                }
            })
        ];
        this.unSubscribePathType2 = this.store.subscribe(() => {
            const enumsState = this.store.getState().enums;
            if (enumsState && enumsState.SourceControlPathTypes) {
                const { SourceControlPathTypes } = enumsState;
                this.pathTypeOptions = Object.values(SourceControlPathTypes).map((name, index) => ({ name, index }));
            }
            if (enumsState.SourceControlPathTypes) {
                this.unSubscribePathType2();
            }
        });
        this.store.dispatch({ type: projectsActions.GET_PROJECTS });
    }

    public ngOnDestroy() {
        this.unSubscribers.forEach(us => us());
    }

    public async assignProject() {
        const tempProjects = this.deepCopy(this.projects);
        const modalProjects = _.differenceBy(tempProjects, this.projectsInProjectGroup, 'id');
        if (modalProjects.length > 0) {
            this.dialogManagerService.showAddFromListDialog(
                {
                    title: 'Select Project',
                    placeholder: 'Search Project',
                    contentClass: '',
                    items: modalProjects
                },
                (data) => {
                    const selectedProjects = data.items.filter(item => item.selected);
                    selectedProjects.forEach((item: any) => {
                        this.projectsInProjectGroup = [...this.projectsInProjectGroup, item];
                    });
                    this._projectGroup.pipelineIds = this.projectsInProjectGroup.map(item => item.id);
                }
            );
        } else {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_NO_PROJECTS']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_PROJECTS']
            });
        }
    }

    public save() {
        if (this._projectGroup.isNew) {
            this._projectGroup.id = -1;
            this.unSubscribe = this.store.subscribe(() => {
                const userState = this.store.getState().user;
                if (userState.projectGroup) {
                    this._projectGroup.id = userState.projectGroup.id;
                    delete this._projectGroup.isNew;
                    this._tempProjectGroup = this.deepCopy(this._projectGroup);
                    this.unSubscribe();
                }
            });
            this.store.dispatch({
                type: userActions.ADD_PROJECT_GROUP,
                payload: { projectGroup: this._projectGroup }
            });
        } else {
            if (this._projectGroup && !this._projectGroup.pipelineIds) {
                this._projectGroup.pipelineIds = [];
            }
            const payload = { projectGroupId: this._projectGroup.id, projectGroup: this._projectGroup };
            this.store.dispatch({
                payload,
                type: userActions.SAVE_PROJECT_GROUP,
                silentRequest: true
            }).then(() => {
                this._tempProjectGroup = this.deepCopy(this._projectGroup);
            }).catch(() => {
                this.cancel();
            });
        }
    }

    public cancel() {
        this._projectGroup.name = this._tempProjectGroup.name;
        this._projectGroup.description = this._tempProjectGroup.description;
        this._projectGroup.pipelineIds = [...this._tempProjectGroup.pipelineIds];
        this._tempProjectGroup = this.deepCopy(this._projectGroup);
        this.setProjectsInGroup();
    }

    private setProjectsInGroup() {
        this.projectsInProjectGroup = [];
        if (this._projectGroup && this._projectGroup.pipelineIds) {
            this._projectGroup.pipelineIds.forEach((id: any) => {
                const project = this.projects && this.projects.find(x => x.id === id);
                if (project) {
                    this.projectsInProjectGroup = [...this.projectsInProjectGroup, project];
                }
            });
        }
    }

    public removeProject(removedProject: any) {
        let index = this.projectsInProjectGroup.findIndex(item => item.id === removedProject.id);
        this.projectsInProjectGroup.splice(index, 1);
        this.projectsInProjectGroup = [...this.projectsInProjectGroup];
        if (this._projectGroup.pipelineIds) {
            index = this._projectGroup.pipelineIds.findIndex((item: any) => item === removedProject.id);
            this._projectGroup.pipelineIds.splice(index, 1);
        }
        if (this.projectsInProjectGroup.length === 0) {
            delete this._projectGroup.pipelineIds;
        }
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/advancedManagement/project-groups/project-group-item/project-group-item.component.ts